export const NEW = 1;
export const IN_QUEUE = 2;
export const GENERATING = 3;
export const READY = 4;
export const NOT_GENERATED = 5;
export const UNKNOWN = -1;
